export default __webpack_public_path__ + "static/media/B0003.7c204ab2.png";